import React from "react";
import { flagUrl, countryName } from "../lib/countries";

// Renders a country flag (flagcdn) with optional name label.
export const Flag = ({ code, lang = "pt", showName = false, className = "" }) => {
  if (!code) return <span className="text-[#0B1D3A]/40">—</span>;
  const name = countryName(code, lang);
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`} data-testid={`flag-${code}`}>
      <img
        src={flagUrl(code)}
        srcSet={`https://flagcdn.com/48x36/${code}.png 2x`}
        width={20}
        height={15}
        alt={name || code}
        title={name || code}
        className="rounded-[2px] shadow-[0_0_0_1px_rgba(0,0,0,0.08)] shrink-0"
        loading="lazy"
      />
      {showName && <span>{name || code.toUpperCase()}</span>}
    </span>
  );
};

export default Flag;
